export default "__VITE_ASSET__BGBv0tke__"